import React from 'react';
import { PHASE } from '../hooks/useGameState';

// ── Countdown ────────────────────────────────────────────────────────────────
export function Countdown({ count }) {
  const color = count <= 1 ? '#E05A5A' : count <= 2 ? '#e07a10' : count === 3 ? '#F0B800' : '#fff';
  return (
    <div style={{
      background: 'rgba(0,0,0,0.9)',
      border: '1px solid #F0B800',
      borderRadius: '10px',
      padding: '20px',
      textAlign: 'center',
    }}>
      <div style={{
        fontFamily: "'DM Mono', monospace",
        fontSize: '11px',
        color: '#666',
        letterSpacing: '2px',
        marginBottom: '8px',
      }}>GET READY</div>
      <div style={{
        fontFamily: "'Bebas Neue', sans-serif",
        fontSize: '80px',
        lineHeight: 1,
        color,
        animation: 'cdPulse 1s ease infinite',
        transition: 'color 0.3s',
      }}>
        {count <= 0 ? 'GO!' : count}
      </div>
      <div style={{
        fontFamily: "'DM Mono', monospace",
        fontSize: '10px',
        color: '#F0B800',
        letterSpacing: '3px',
        marginTop: '8px',
      }}>CHICKEN DROP ARENA</div>
    </div>
  );
}

// ── Stats panel ──────────────────────────────────────────────────────────────
export function Stats({ game, onStart }) {
  const squareCount = Object.keys(game.squares).length;
  const canStart = squareCount >= 1 && game.phase === PHASE.WAITING;

  return (
    <div style={{
      background: '#111',
      border: '1px solid #2a2a2a',
      borderRadius: '10px',
      padding: '16px',
    }}>
      <div style={{
        fontFamily: "'DM Mono', monospace",
        fontSize: '11px',
        color: '#666',
        letterSpacing: '2px',
        marginBottom: '12px',
      }}>CHICKEN DROP STATS</div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '14px' }}>
        {[
          { label: 'Squares assigned', value: squareCount },
          { label: 'Players', value: new Set(Object.values(game.squares).map(s => s.walletAddress)).size },
          { label: 'Prize pool', value: `${game.totalPot} SOL` },
          { label: 'Prize', value: `${game.settledPrize || game.displayPool.toFixed(3)} SOL` },
        ].map(({ label, value }) => (
          <div key={label} style={{
            background: '#0d0d0d',
            borderRadius: '6px',
            padding: '10px',
            border: '1px solid #222',
          }}>
            <div style={{ fontFamily: "'DM Mono', monospace", fontSize: '10px', color: '#555', marginBottom: '4px' }}>{label}</div>
            <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '20px', color: '#E8E8E8', letterSpacing: '1px' }}>{value}</div>
          </div>
        ))}
      </div>


      {/* Ticket price info */}
      <div style={{
        marginTop: '12px',
        padding: '8px',
        background: '#0d0d0d',
        borderRadius: '6px',
        fontFamily: "'DM Mono', monospace",
        fontSize: '10px',
        color: '#444',
        textAlign: 'center',
        lineHeight: 1.8,
      }}>
        Play Chicken Droppings to earn a square · 0.02 SOL entry fee
      </div>
    </div>
  );
}

// ── Game log ─────────────────────────────────────────────────────────────────
export function GameLog({ entries }) {
  return (
    <div style={{
      background: '#111',
      border: '1px solid #2a2a2a',
      borderRadius: '10px',
      padding: '16px',
    }}>
      <div style={{
        fontFamily: "'DM Mono', monospace",
        fontSize: '11px',
        color: '#666',
        letterSpacing: '2px',
        marginBottom: '10px',
      }}>GAME LOG</div>
      <div style={{
        background: '#0d0d0d',
        borderRadius: '6px',
        padding: '10px',
        maxHeight: '220px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
      }}>
        {entries.map((entry, i) => {
          const isWin = entry.includes('WINNER') || entry.includes('GOLDEN EGG');
          const isError = entry.includes('✗') || entry.includes('failed');
          const isSuccess = entry.includes('✓');
          const color = isWin ? '#F0B800' : isError ? '#E05A5A' : isSuccess ? '#4CAF50' : '#555';
          return (
            <div key={i} style={{
              fontFamily: "'DM Mono', monospace",
              fontSize: '11px',
              color,
              lineHeight: 1.6,
              animation: i === entries.length - 1 ? 'fadeIn 0.3s ease' : 'none',
            }}>
              {entry}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Countdown;
